/* Ferrefix Custom JS — v6 ROOT CAUSE FIX: overflow:hidden in header section wrapper

   DISCOVERY (2026-05-09): el bug del dropdown detrás del hero NUNCA fue z-index.
   El div wrapper <div id="shopify-section-...__header"> tiene overflow:hidden auto,
   lo que CLIPEA el dropdown a la altura del header. Por eso ningún z-index lo arreglaba —
   el dropdown se renderizaba con z-index correcto, pero estaba cortado a 99px de altura.

   FIX DEFINITIVO: overflow:visible en TODOS los wrappers del header. */
(function ffHeaderFixRuntime(){
  var css = ''
    /* THE CRITICAL ROOT-CAUSE FIX: overflow visible en TODOS los wrappers padre del header */
    + '.shopify-section-group-header-group,'
    + '.shopify-section.section-header,'
    + '.shopify-section.shopify-section-header-sticky,'
    + 'div[id^="shopify-section-"][id*="__header"],'
    + '.section-header,'
    + '.shopify-section-header,'
    + 'sticky-header,'
    + 'sticky-header.header-wrapper,'
    + '.header-wrapper,'
    + '.header__inline-menu,'
    + '.header__inline-menu nav,'
    + '.header__inline-menu .list-menu,'
    + 'header.header,'
    + 'header-menu,'
    + '.shopify-section-group-header-group .shopify-section{'
    + 'overflow:visible!important;'
    + 'overflow-x:visible!important;'
    + 'overflow-y:visible!important'
    + '}'
    /* Submenu visible: opacity 1, sin animaciones rotas */
    + '.header__submenu,'
    + '.header__submenu.global-settings-popup,'
    + 'details[open]>.header__submenu,'
    + 'details[open]>.header__submenu.global-settings-popup{'
    + 'opacity:1!important;'
    + 'visibility:visible!important;'
    + 'animation:none!important;'
    + 'transition:none!important;'
    + 'transform:none!important;'
    + 'z-index:101!important;'
    + 'background-color:#1C1C1C!important;'
    + 'background-image:none!important;'
    + 'min-width:320px!important;'
    + 'max-height:none!important;'
    + 'border-radius:0 0 12px 12px!important;'
    + 'box-shadow:0 20px 60px rgba(0,0,0,0.6)!important;'
    + 'padding:0.5rem 0!important'
    + '}'
    /* Submenu items: visibles, padding, hover color */
    + '.header__submenu li{'
    + 'opacity:1!important;'
    + 'visibility:visible!important;'
    + 'transform:none!important;'
    + 'animation:none!important;'
    + 'display:block!important'
    + '}'
    + '.header__submenu .header__menu-item,'
    + '.header__submenu a.list-menu__item{'
    + 'opacity:1!important;'
    + 'visibility:visible!important;'
    + 'display:block!important;'
    + 'color:rgba(250,250,250,0.95)!important;'
    + 'padding:0.875rem 1.5rem!important;'
    + 'transition:background-color 0.15s,color 0.15s,padding-left 0.2s!important'
    + '}'
    + '.header__submenu .header__menu-item:hover,'
    + '.header__submenu a.list-menu__item:hover{'
    + 'background-color:rgba(249,115,22,0.15)!important;'
    + 'color:#F97316!important;'
    + 'padding-left:1.75rem!important'
    + '}'
    /* Stacking context: header gana sobre cualquier sección hermana */
    + '.section-header,'
    + '.shopify-section-header,'
    + 'div[id^="shopify-section-"][id*="__header"]{'
    + 'z-index:100!important;'
    + 'position:relative!important'
    + '}'
    + '.header-wrapper,'
    + 'sticky-header.header-wrapper{'
    + 'isolation:isolate!important;'
    + 'z-index:100!important;'
    + 'position:relative!important;'
    + 'background-color:#1C1C1C!important'
    + '}';

  var style = document.createElement('style');
  style.id = 'ff-header-fix-runtime';
  style.textContent = css;
  if (document.head) {
    document.head.appendChild(style);
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      document.head.appendChild(style);
    });
  }
})();

/* ═══════════════════════════════════════════════════════════════
   FERREFIX COLOR SWATCHES — runtime PDP color selector
   Auto-detecta productos hermanos por naming pattern "Nombre - Color"
   Se auto-inserta en la PDP después del price/stock, aunque el snippet
   Liquid aún no esté en el HTML cached.
   ═══════════════════════════════════════════════════════════════ */
(function ffColorSwatchesRuntime(){
  if (window.__ffColorSwatchesApplied) return;
  window.__ffColorSwatchesApplied = true;

  /* Only run on product pages */
  var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__title, [class*="ProductTitle"]');
  if (!titleEl) return;

  /* Get clean title: try meta OG title first, then h1 first line to avoid duplicated content */
  var title = '';
  var ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && ogTitle.content) {
    title = ogTitle.content.trim();
  } else {
    /* h1.textContent may contain repeated child text; take only first non-empty line */
    var lines = titleEl.textContent.split('\n').map(function(l){ return l.trim(); }).filter(Boolean);
    title = lines[0] || '';
  }
  if (!title) return;

  /* Colors dictionary (Spanish + common variants) */
  var COLOR_WORDS = 'blanco,blanca,negro,negra,gris,azul,rojo,roja,verde,amarillo,amarilla,naranja,rosa,marron,marrón,beige,grafito,petroleo,petróleo,fucsia,celeste,turquesa,bordo,bordeaux,crema,arena,camel,oliva,coral,violeta,morado,vino,plateado,dorado,plata,oro,antracita,caqui,khaki,mostaza,salmon,salmón,melange,natural,piedra,oscuro,claro,cobre,chocolate,tabaco,vison,visón,avellana,curry,lima,menta,manzana,esmeralda,jade,marino,francia,denim,indigo'.split(',');

  var COLOR_MAP = {
    blanco:'#FFFFFF',blanca:'#FFFFFF',negro:'#1C1C1C',negra:'#1C1C1C',
    gris:'#808080',grafito:'#3A3A3A',antracita:'#292929',plata:'#C0C0C0',plateado:'#C0C0C0',
    azul:'#1E40AF',celeste:'#87CEEB',turquesa:'#40E0D0',marino:'#0A2540',francia:'#0055A4',denim:'#4E6E8E',indigo:'#4B0082',petroleo:'#005F73','petróleo':'#005F73',
    rojo:'#DC2626',roja:'#DC2626',bordo:'#7B1E1E',bordeaux:'#7B1E1E',vino:'#722F37',coral:'#FF7F50',salmon:'#FA8072','salmón':'#FA8072',
    verde:'#166534',oliva:'#556B2F',esmeralda:'#046A38',jade:'#00A86B',menta:'#98FB98',manzana:'#8DB600',lima:'#BFFF00',oscuro:'#0d3018',claro:'#66C266',
    amarillo:'#EAB308',amarilla:'#EAB308',mostaza:'#B58900',curry:'#B58900',oro:'#DAA520',dorado:'#DAA520',
    naranja:'#F97316',cobre:'#B87333',
    rosa:'#FBAFAF',fucsia:'#FF00FF',violeta:'#8A2BE2',morado:'#7B2CBF',
    marron:'#5D3A1F','marrón':'#5D3A1F',chocolate:'#3B2114',tabaco:'#4A2E0F',vison:'#5C4033','visón':'#5C4033',avellana:'#8B6A45',camel:'#C19A6B',
    beige:'#D6C7A1',crema:'#F5E6C8',arena:'#C2A878',piedra:'#B7A99A',natural:'#D9C9A8',khaki:'#8B7E4C',caqui:'#8B7E4C',
    melange:'#8A8D95'
  };

  function parseTitle(t) {
    var m = t.match(/^(.+?)\s*[-–]\s*([^-–]+)$/);
    if (!m) return null;
    var basePart = m[1].trim();
    var colorPart = m[2].trim();
    var firstWord = colorPart.toLowerCase().split(/\s+/)[0];
    if (COLOR_WORDS.indexOf(firstWord) === -1) return null;
    return { base: basePart, color: colorPart };
  }

  function normalize(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }

  function colorToHex(colorName) {
    var lc = colorName.toLowerCase().trim();
    if (COLOR_MAP[lc]) return COLOR_MAP[lc];
    var words = lc.split(/\s+/);
    for (var i = 0; i < words.length; i++) if (COLOR_MAP[words[i]]) return COLOR_MAP[words[i]];
    return null;
  }

  var parsed = parseTitle(title);
  if (!parsed) return;

  var baseName = normalize(parsed.base);

  /* Get current vendor */
  var vendor = '';
  var vendorEl = document.querySelector('.product__text, [class*="vendor"], .caption-with-letter-spacing');
  if (vendorEl) vendor = vendorEl.textContent.trim().toLowerCase();

  /* Get current handle from URL */
  var currentHandle = window.location.pathname.split('/products/')[1];
  if (currentHandle) currentHandle = currentHandle.split('/')[0].split('?')[0];

  /* Inject CSS */
  var css = ''
    + '.ff-swatches-rt{margin:0.75rem 0 1rem;padding:0.75rem 0}'
    + '.ff-swatches-rt__header{display:flex;align-items:baseline;gap:0.4rem;margin-bottom:0.5rem;font-size:0.9rem;color:#555}'
    + '.ff-swatches-rt__label{font-weight:500}'
    + '.ff-swatches-rt__current{color:#1C1C1C;font-weight:700;text-transform:capitalize}'
    + '.ff-swatches-rt__list{display:flex;flex-wrap:wrap;gap:0.5rem}'
    + '.ff-swatch-rt{position:relative;display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;padding:3px;border:2px solid rgba(0,0,0,0.12);border-radius:50%;background:#fff;cursor:pointer;text-decoration:none;transition:border-color 0.15s,transform 0.15s,box-shadow 0.15s;box-sizing:border-box}'
    + '.ff-swatch-rt:hover{border-color:#F97316;transform:translateY(-2px) scale(1.05);box-shadow:0 4px 12px rgba(0,0,0,0.12)}'
    + '.ff-swatch-rt--current{border-color:#F97316 !important;box-shadow:0 0 0 2px rgba(249,115,22,0.25);pointer-events:none;cursor:default}'
    + '.ff-swatch-rt__color{display:block;width:100%;height:100%;border-radius:50%;border:1px solid rgba(0,0,0,0.08);box-sizing:border-box}'
    + '.ff-swatch-rt__color--multi{background:conic-gradient(#ef4444,#f59e0b,#10b981,#3b82f6,#8b5cf6,#ef4444)}'
    + '.ff-swatch-rt__tooltip{position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);background:#1C1C1C;color:#fff;font-size:0.72rem;font-weight:600;padding:0.3rem 0.55rem;border-radius:5px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity 0.15s;text-transform:capitalize;z-index:10}'
    + '.ff-swatch-rt__tooltip::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:4px solid transparent;border-top-color:#1C1C1C}'
    + '.ff-swatch-rt:hover .ff-swatch-rt__tooltip{opacity:1}'
    + '@media (max-width:749px){.ff-swatch-rt{width:44px;height:44px}}';

  var styleEl = document.createElement('style');
  styleEl.id = 'ff-swatches-rt-styles';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* Fetch siblings via search API */
  fetch('/search/suggest.json?q=' + encodeURIComponent(parsed.base) + '&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=last')
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(data){
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) return fallbackFetch();
      render(products);
    })
    .catch(fallbackFetch);

  function fallbackFetch(){
    fetch('/products.json?limit=250')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (d && d.products) render(d.products);
      });
  }

  function render(products) {
    var matches = [];
    products.forEach(function(p){
      if (!p.title || !p.handle) return;
      if (vendor && p.vendor && p.vendor.toLowerCase() !== vendor) return;
      var pp = parseTitle(p.title);
      if (!pp) return;
      if (normalize(pp.base) === baseName) {
        matches.push({ handle: p.handle, title: p.title, color: pp.color });
      }
    });

    /* Include current product if search missed it */
    if (currentHandle && !matches.some(function(m){ return m.handle === currentHandle; })) {
      matches.push({ handle: currentHandle, title: title, color: parsed.color });
    }

    /* Dedupe */
    var seen = {};
    matches = matches.filter(function(m){
      if (seen[m.handle]) return false;
      seen[m.handle] = true;
      return true;
    });

    if (matches.length < 2) return;

    matches.sort(function(a, b){
      if (a.handle === currentHandle) return -1;
      if (b.handle === currentHandle) return 1;
      return a.color.localeCompare(b.color);
    });

    /* Build DOM */
    var container = document.createElement('div');
    container.className = 'ff-swatches-rt';
    container.innerHTML =
      '<div class="ff-swatches-rt__header">' +
      '<span class="ff-swatches-rt__label">Color:</span>' +
      '<strong class="ff-swatches-rt__current"></strong>' +
      '</div>' +
      '<div class="ff-swatches-rt__list"></div>';

    container.querySelector('.ff-swatches-rt__current').textContent = parsed.color;
    var list = container.querySelector('.ff-swatches-rt__list');

    matches.forEach(function(m){
      var isCurrent = m.handle === currentHandle;
      var link = document.createElement(isCurrent ? 'span' : 'a');
      if (!isCurrent) link.href = '/products/' + m.handle;
      link.className = 'ff-swatch-rt' + (isCurrent ? ' ff-swatch-rt--current' : '');
      link.setAttribute('aria-label', m.color + (isCurrent ? ' (actual)' : ''));

      var colorEl = document.createElement('span');
      colorEl.className = 'ff-swatch-rt__color';
      var hex = colorToHex(m.color);
      if (hex) colorEl.style.background = hex;
      else colorEl.classList.add('ff-swatch-rt__color--multi');
      link.appendChild(colorEl);

      var tooltip = document.createElement('span');
      tooltip.className = 'ff-swatch-rt__tooltip';
      tooltip.textContent = m.color;
      link.appendChild(tooltip);

      list.appendChild(link);
    });

    /* Insert after price element */
    var priceEl = document.querySelector('.price, .product__price, [class*="ProductPrice"], .ff-mp')
      || document.querySelector('.product-form__buttons')
      || titleEl;
    if (priceEl && priceEl.parentNode) {
      /* Insert after price */
      if (priceEl.nextSibling) {
        priceEl.parentNode.insertBefore(container, priceEl.nextSibling);
      } else {
        priceEl.parentNode.appendChild(container);
      }
    }
  }
})();

(function () {
  'use strict';

  // ── Sticky header color change on scroll ──
  const header = document.querySelector('.shopify-section-header-sticky, header-section, .header-wrapper');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('header--scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  // ── Trust bar IntersectionObserver reveal ──
  const trustItems = document.querySelectorAll('.multicolumn .multicolumn-list__item');
  if (trustItems.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 100);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    trustItems.forEach(item => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
      item.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(item);
    });
  }

  // ── Back to top button ──
  const backToTop = document.getElementById('ferrefix-back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── Add to cart micro bounce ──
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="add"], .product-form__submit');
    if (btn) {
      btn.classList.remove('cart-btn-bounce');
      void btn.offsetWidth;
      btn.classList.add('cart-btn-bounce');
      setTimeout(() => btn.classList.remove('cart-btn-bounce'), 400);
    }
  });
})();
/* force-deploy-1781644405 */
/* v6-overflow-fix-1781645023 */
/* swatches-runtime-1785725032 */
/* title-clean-fix-1785780219 */
